import React from 'react';
import { connect } from 'react-redux'
import ConfirmadorSolicitud from './ConfirmadorSolicitud';

//Importación de actions.
import {
    getScreenData,
    goTo,
    cambiarEstado,
    cerrarModal,
    resetStateConfirmadorSolicitud
} from '../actions/Actions';


const mapStateToProps = (state) => {
    return {
        confirmadorSolicitud: state.confirmadorSolicitud,
        sesion: state.sesion
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetStateConfirmadorSolicitud: () => {
            dispatch(resetStateConfirmadorSolicitud());
        },
        getScreenData: (currentScope, sesion) => {
            dispatch(getScreenData(currentScope, sesion));
        },
        goTo: (entidadAdirijirse) => {
            dispatch(goTo(entidadAdirijirse));
        },
        cambiarEstado: (estado) => {
            dispatch(cambiarEstado(estado));
        },
        cerrarModal: () => {
            dispatch(cerrarModal());
        }
    }
}

//Connect entre el componente y las props y actions.
const ConfirmadorSolicitudContainer = connect(mapStateToProps, mapDispatchToProps)(ConfirmadorSolicitud);

export default ConfirmadorSolicitudContainer;